import { jsx as _jsx } from "react/jsx-runtime";
import { useCategoryStore } from '../../../../store/category';
export default function AttributeColor({ attribute, updateVariantValues }) {
    const setFilter = useCategoryStore((state) => state.setFilter);
    const filter = useCategoryStore((state) => state.filter.attributes);
    const valueAttribute = filter.find((item) => item.id === attribute.id);
    return (_jsx("div", { className: "values emulated-flex-gap", children: attribute.values.map((value) => (_jsx("div", { onClick: () => {
                setFilter({ selectedValue: { attribute, value } });
                updateVariantValues(attribute, value);
            }, className: `color mr-1`, style: { backgroundColor: value.color }, children: valueAttribute?.values.includes(value.id) && _jsx("span", { className: "active" }) }, `attribute-${attribute.id}-value-${value.id}`))) }));
}
